/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'cross_product_search_dialog.atlas.tab_label': 'Atlas',
  'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
  'cross_product_search_dialog.confluence.tab_label': 'Confluence',
  'cross_product_search_dialog.google_drive.tab_label': 'Google Drive',
  'cross_product_search_dialog.google_drive.unauthenticated_prompt':
    'Sie können an allen Ihren Google-Tabellen, -Dokumenten, -Präsentationen und mehr arbeiten, ohne Atlassian jemals verlassen zu müssen. Nur Sie haben diesen Zugriff.',
  'cross_product_search_dialog.jira.tab_label': 'Jira',
  'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
  'cross_product_search_dialog.recently_viewed_title': 'Zuletzt angesehene {sectionTitle}',
  'cross_product_search_dialog.townsquare_globex_tab_label': 'Startseite',
  'cross_product_search_dialog.townsquare_recent_goals': 'Letzte Ziele',
  'cross_product_search_dialog.townsquare_recent_help_links': 'Zuletzt aufgerufene Hilfe-Links',
  'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions':
    'Aktuelle Erkenntnisse, Risiken und Entscheidungen',
  'cross_product_search_dialog.townsquare_recent_projects': 'Letzte Projekte',
  'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
  'cross_product_search_dialog.trello.tab_label': 'Trello',
  'cross_product_search_dialog.view_all_results_link': 'Alle {sectionTitle} anzeigen',
  'extensible_search_dialog.advanced_search': 'Erweiterte Suche',
  'extensible_search_dialog.connect': 'Verbinden',
  'extensible_search_dialog.connect_to': 'Verbindung herstellen zu',
  'global_search.jira.advanced_search_boards': 'Boards',
  'global_search.jira.advanced_search_filters': 'Filter',
  'global_search.jira.advanced_search_issues': 'Vorgänge',
  'global_search.jira.advanced_search_label': 'Zu allen:',
  'global_search.jira.advanced_search_people': 'Personen',
  'global_search.jira.advanced_search_plans': 'Pläne',
  'global_search.jira.advanced_search_projects': 'Projekte',
  'global_search.jira.search_placeholder': 'Jira durchsuchen',
  'global_search.jira.search_placeholder_experiment_jsw_enabled':
    'Suchen nach Vorgängen, Boards, Projekten und Filtern',
  'product_s earch_dialog.confluence.assignee_filters_find_more': 'Zugewiesene Person suchen',
  'product_search_dialog.atlas.search_input_expanded_placeholder': 'Atlas durchsuchen',
  'product_search_dialog.autocorrection.label': 'Meinten Sie',
  'product_search_dialog.bitbucket.bitbucket_advanced_search': 'In {source} nach Code suchen',
  'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Zuletzt aktualisierte Repositorys',
  'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositorys',
  'product_search_dialog.bitbucket.expanded.input-placeholder': 'Bitbucket durchsuchen',
  'product_search_dialog.bitbucket.repository_heading': 'Repositorys',
  'product_search_dialog.common.site_filters': 'Nach Site filtern',
  'product_search_dialog.compass.component_type.application': 'Anwendung',
  'product_search_dialog.compass.component_type.capability': 'Funktion',
  'product_search_dialog.compass.component_type.cloud_resource': 'Cloud-Ressource',
  'product_search_dialog.compass.component_type.data_pipeline': 'Daten-Pipeline',
  'product_search_dialog.compass.component_type.library': 'Bibliothek',
  'product_search_dialog.compass.component_type.machine_learning_model': 'Modell für maschinelles Lernen',
  'product_search_dialog.compass.component_type.other': 'Sonstiges',
  'product_search_dialog.compass.component_type.service': 'Service',
  'product_search_dialog.compass.component_type.ui_element': 'UI-Element',
  'product_search_dialog.compass.component_type.website': 'Website',
  'product_search_dialog.compass.components_section_heading': 'Komponenten',
  'product_search_dialog.compass.expanded.input-placeholder': 'Compass durchsuchen',
  'product_search_dialog.compass.people_section_heading': 'Personen',
  'product_search_dialog.compass.recently_viewed_components': 'Kürzlich angesehene Komponenten',
  'product_search_dialog.compass.recently_viewed_teams': 'Kürzlich angesehene Teams',
  'product_search_dialog.compass.tab_label': 'Compass',
  'product_search_dialog.compass.teams_section_heading': 'Teams',
  'product_search_dialog.compass.upsell_modal_cta_text': 'Compass kostenlos nutzen',
  'product_search_dialog.compass.upsell_modal_description':
    'Katalogisieren Sie Ihre Softwarearchitektur an einem Ort. Denn auf diese Weise können die Teams, die daran arbeiten, Kontextwechsel reduzieren, schneller finden, was sie benötigen, und produktiver arbeiten. Wie wäre das als Entwicklererfahrung?',
  'product_search_dialog.compass.upsell_modal_description.bitbucket':
    'Lassen Sie sich Besitzer, Abhängigkeiten und Hilferessourcen für Ihre Repositorys anzeigen, indem Sie sie mit einem zentralen Softwarekatalog verknüpfen.',
  'product_search_dialog.compass.upsell_modal_heading':
    'Kontrollieren Sie Ihren Software-Sprawl, damit Entwickler ihre Zeit kontrollieren können',
  'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Mehr Kontext für Ihren Code',
  'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Weitere Informationen zu Compass',
  'product_search_dialog.compass.upsell_modal_learn_more_link': 'Mehr erfahren',
  'product_search_dialog.compass.upsell_tab_title_lozenge': 'Neu',
  'product_search_dialog.compass.view_all_components_label': 'Alle Komponenten anzeigen',
  'product_search_dialog.compass.view_all_results_label': 'Alle Ergebnisse anzeigen',
  'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Erweiterte Confluence-Suche',
  'product_search_dialog.confluence.clear_filters': 'Filter löschen',
  'product_search_dialog.confluence.content_section_heading': 'Inhalt',
  'product_search_dialog.confluence.contributor_filters': 'Nach Beitragendem filtern',
  'product_search_dialog.confluence.contributor_filters_find_more': 'Einen Beitragenden suchen',
  'product_search_dialog.confluence.date_filter_title': 'Letzte Aktualisierung',
  'product_search_dialog.confluence.date_filter_today': 'Heute',
  'product_search_dialog.confluence.date_filter_yesterday': 'Gestern',
  'product_search_dialog.confluence.date_filters_any': 'Beliebiger Zeitpunkt',
  'product_search_dialog.confluence.date_filters_month': 'Letzte 30 Tage',
  'product_search_dialog.confluence.date_filters_week': 'Letzte 7 Tage',
  'product_search_dialog.confluence.date_filters_year': 'Letztes Jahr',
  'product_search_dialog.confluence.empty_state_body_no_advanced_search':
    'Probieren Sie verschiedene Stichwörter aus oder versuchen Sie es mit allgemeineren Begriffen.',
  'product_search_dialog.confluence.empty_state_body_prequery_filters':
    'Mit den ausgewählten Filtern konnten keine Elemente gefunden werden, die in den letzten 90 Tagen erstellt oder aktualisiert wurden.',
  'product_search_dialog.confluence.empty_state_body_title':
    'Es konnten keine passenden Treffer für Ihre Suche gefunden werden.',
  'product_search_dialog.confluence.filters_applied': 'Sie haben einige Filter angewendet.',
  'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Seiten, Blogs und Anhänge',
  'product_search_dialog.confluence.people_section_heading': 'Personen',
  'product_search_dialog.confluence.search_input_expanded_placeholder': 'Confluence durchsuchen',
  'product_search_dialog.confluence.search_input_expanded_placeholder_ai':
    'In Confluence suchen oder eine Frage stellen',
  'product_search_dialog.confluence.space_filters': 'Nach Bereich filtern',
  'product_search_dialog.confluence.space_filters_find_more': 'Bereich suchen',
  'product_search_dialog.confluence.spaces_section_heading': 'Bereiche',
  'product_search_dialog.confluence.typing_state_header_text': 'Nach Inhalten in Confluence suchen',
  'product_search_dialog.empty.no_results_body':
    'Versuchen Sie es mit einem anderen Begriff erneut oder verfeinern Sie Ihre Suchergebnisse mit der <a>erweiterten Suche</a>.',
  'product_search_dialog.empty.no_results_body_no_advanced_search':
    'Versuchen Sie es mit einem anderen Begriff erneut.',
  'product_search_dialog.empty.no_results_heading':
    'Es konnten keine passenden Ergebnisse gefunden werden, die mit Ihrem Suchbegriff übereinstimmen.',
  'product_search_dialog.empty_prequery.error_heading':
    'Beim Anzeigen der ersten Ergebnisse ist ein Fehler aufgetreten.',
  'product_search_dialog.empty_prequery.no_results_heading': 'Suchen Sie nach allem, was Sie benötigen',
  'product_search_dialog.error.failed_search_body':
    'Das war vielleicht nur eine kurze Störung. <a>Versuchen Sie es am besten erneut.</a>',
  'product_search_dialog.error.failed_search_heading': 'Wir haben Schwierigkeiten bei der Suche',
  'product_search_dialog.give_feedback': 'Feedback geben',
  'product_search_dialog.google_drive.files_heading': 'Dateien',
  'product_search_dialog.inline_onboarding_action': 'OK',
  'product_search_dialog.inline_onboarding_body':
    'Nutzen Sie die Registerkarten für Jira und Confluence, um nach aktuellen Elementen zu suchen oder diese in den jeweiligen Tools anzeigen zu lassen.',
  'product_search_dialog.inline_onboarding_title': 'In Jira und Confluence suchen',
  'product_search_dialog.jira.assignee_filters': 'Nach zugewiesener Person filtern',
  'product_search_dialog.jira.boards_icon_accessibility_text': 'Board-Symbol',
  'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projekte, Filter und Pläne',
  'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projekte und Filter',
  'product_search_dialog.jira.date_filter_30': '30 T',
  'product_search_dialog.jira.date_filter_60': '60 T',
  'product_search_dialog.jira.date_filter_90': '90 T',
  'product_search_dialog.jira.date_filter_any': 'Jederzeit',
  'product_search_dialog.jira.date_filter_past_30_days': 'Letzte 30 Tage',
  'product_search_dialog.jira.date_filter_past_7_days': 'Letzte 7 Tage',
  'product_search_dialog.jira.date_filter_past_year': 'Letztes Jahr',
  'product_search_dialog.jira.date_filter_today': 'Heute',
  'product_search_dialog.jira.date_filter_yesterday': 'Gestern',
  'product_search_dialog.jira.date_filters': 'Letzte Aktualisierung',
  'product_search_dialog.jira.empty_prequery.no_results_heading':
    'Beginnen Sie mit der Suche, um Ihre Arbeit zu finden',
  'product_search_dialog.jira.issue_filter_done': 'Fertig',
  'product_search_dialog.jira.issue_filter_open': 'Offen',
  'product_search_dialog.jira.issue_filters': 'Nach Status filtern',
  'product_search_dialog.jira.issue_labels_filters': 'Nach Stichwort filtern',
  'product_search_dialog.jira.issue_labels_filters_options_group_label': 'Alle Stichwörter',
  'product_search_dialog.jira.issue_labels_filters_placeholder': 'Stichwort auswählen',
  'product_search_dialog.jira.issues_section_heading': 'Vorgänge',
  'product_search_dialog.jira.jira_view_all_issues_new': 'Alle Vorgänge anzeigen',
  'product_search_dialog.jira.project_filters': 'Nach Projekt filtern',
  'product_search_dialog.jira.project_filters_find_more': 'Projekt suchen',
  'product_search_dialog.jira.projects_filters_section_heading': 'Projekte und Filter',
  'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading':
    'Zuletzt angesehene Boards, Projekte, Filter und Pläne',
  'product_search_dialog.jira.recent_boards_projects_filters_section_heading':
    'Zuletzt angesehene Boards, Projekte und Filter',
  'product_search_dialog.jira.recent_projects_filters_section_heading': 'Zuletzt angesehene Projekte und Filter',
  'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Zuletzt angesehene Vorgänge',
  'product_search_dialog.jira.report_by_filters': 'Nach Autor filtern',
  'product_search_dialog.jira.reported_by_me_filter': 'Von mir gemeldet',
  'product_search_dialog.jira.site_filters_find_more': 'Eine Site suchen',
  'product_search_dialog.jira.view_all_issues': 'Erweiterte Vorgangssuche',
  'product_search_dialog.loading_filters': 'Wird geladen …',
  'product_search_dialog.more_filters': 'Alle Filter anzeigen',
  'product_search_dialog.multi_site_advanced_search_label': 'Suchen auf:',
  'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} weitere',
  'product_search_dialog.no_options_filters': 'Keine Optionen',
  'product_search_dialog.opsgenie.advanced_search': 'Erweiterte Warnsuche',
  'product_search_dialog.opsgenie.alert_heading': 'Warnungen',
  'product_search_dialog.opsgenie.expanded.input-placeholder': 'In Opsgenie suchen',
  'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Letzte Warnmeldungen',
  'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Atlassian Intelligence fragen',
  'product_search_dialog.quick_find_confluence_space': 'Confluence-Bereich',
  'product_search_dialog.quick_find_footer_full_page_search_link': 'Ihre Organisation durchsuchen',
  'product_search_dialog.quick_find_footer_text': 'Hilf uns dabei, das Sucherlebnis zu verbessern.',
  'product_search_dialog.quick_find_no_content_body':
    'Suchen oder fragen Sie nach allem, was Sie in Ihren Atlassian-Produkten nicht finden können.',
  'product_search_dialog.quick_find_no_content_header': 'Wer suchet, der findet',
  'product_search_dialog.quick_find_recent_draft_label': 'ENTWURF',
  'product_search_dialog.quick_find_recent_search': 'Letzter Suchvorgang',
  'product_search_dialog.quick_find_recent_search_text_dialog': 'Aus Ihren letzten Suchanfragen',
  'product_search_dialog.quick_find_recent_spaces_additional_meta': 'Zuletzt besucht',
  'product_search_dialog.quick_find_recently_viewed': 'Kürzlich angesehen',
  'product_search_dialog.quick_find_result_item_team': 'Team',
  'product_search_dialog.quick_find_results_section': 'Suchergebnisse',
  'product_search_dialog.quick_find_search_input_placeholder':
    'Führen Sie eine Suche durch oder stellen Sie eine beliebige Frage',
  'product_search_dialog.quick_find_search_results': 'Suchergebnisse',
  'product_search_dialog.quick_find_show_filtered_results':
    'Nach Confluence-Bereich, Beitragenden und anderen Kriterien filtern',
  'product_search_dialog.quick_find_show_organization_results': 'Ihre Organisation durchsuchen',
  'product_search_dialog.recent_spaces_section_heading': 'Neueste Bereiche',
  'product_search_dialog.recently_viewed_heading': 'Erweiterte Suche',
  'product_search_dialog.recently_viewed_section_heading': 'Kürzlich angesehen',
  'product_search_dialog.recently_worked_with_section_heading': 'Kürzlich gearbeitet mit',
  'product_search_dialog.search_input_collapsed_placeholder': 'Suchen',
  'product_search_dialog.search_people_link': 'Personen suchen',
  'product_search_dialog.show_all_results_link': 'Alle Ergebnisse anzeigen',
  'product_search_dialog.show_more_results_link': 'Mehr anzeigen',
  'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Startseite durchsuchen',
  'product_search_dialog.townsquare_goals_heading': 'Ziele',
  'product_search_dialog.townsquare_goals_view_all': 'Alle Ziele suchen',
  'product_search_dialog.townsquare_help_links_heading': 'Hilfe-Links',
  'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Erkenntnisse, Risiken und Entscheidungen',
  'product_search_dialog.townsquare_people_heading': 'Personen',
  'product_search_dialog.townsquare_people_view_all': 'Alle Personen suchen',
  'product_search_dialog.townsquare_projects_heading': 'Projekte',
  'product_search_dialog.townsquare_projects_view_all': 'Alle Projekte suchen',
  'product_search_dialog.townsquare_recent_people': 'Zuletzt aufgerufene Personen',
  'product_search_dialog.townsquare_recent_topics': 'Aktuelle Themen',
  'product_search_dialog.townsquare_teams_heading': 'Teams',
  'product_search_dialog.townsquare_teams_view_all': 'Alle Teams suchen',
  'product_search_dialog.townsquare_topics_heading': 'Themen',
  'product_search_dialog.townsquare_topics_view_all': 'Alle Themenbereiche suchen',
  'product_search_dialog.trello.archived': 'Archiviert',
  'product_search_dialog.trello.archived.card-hover': 'Diese Karte ist archiviert.',
  'product_search_dialog.trello.board': 'Board',
  'product_search_dialog.trello.boards_heading': 'Boards',
  'product_search_dialog.trello.cards_heading': 'Karten',
  'product_search_dialog.trello.closed': 'Geschlossen',
  'product_search_dialog.trello.closed.board-hover': 'Dieses Board ist geschlossen.',
  'product_search_dialog.trello.expanded.input-placeholder': 'Trello durchsuchen',
  'product_search_dialog.trello.feedback_link': 'Helfen Sie uns dabei, Ihre Suchergebnisse zu verbessern!',
  'product_search_dialog.trello.list': 'Liste',
  'product_search_dialog.trello.private_workspace': 'Privater Arbeitsbereich',
  'product_search_dialog.trello.recent_boards_heading': 'Aktuelle Boards',
  'product_search_dialog.trello.workspace': 'Arbeitsbereich',
  'product_search_dialog.updated_date_formatter': 'Aktualisiert am {date}',
  'search_dialog.filters.group.show-more': 'Mehr anzeigen',
  'search_dialog.search_input_clear_label': 'Suchsitzung löschen',
  'search_dialog.search_input_exit_label': 'Suche beenden',
};
